import React from 'react'
import { withTranslationCustom } from 'lib/i18next'
import ErrorMessageContent from './ErrorMessageContent'
import AuthLoginButton from 'components/Auth/AuthLoginButton/AuthLoginButton'

const LoginMessage = ({ t }) => {
    return (
        <ErrorMessageContent
            title={t('errorMessage.401.title')}
            content={(
                <p>
                    {t('errorMessage.401.content')}
                </p>
            )}
            actions={(
                <AuthLoginButton className="button">
                    {t('common:signIn')}
                </AuthLoginButton>
            )}
        />
    )
}

export default withTranslationCustom(['errors', 'common'])(LoginMessage)
